import { EdgeCompleteRegistrationRepository } from '@/modules/auth/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { CompleteRegistrationFromInvitation } from '@/modules/auth/use-cases'

export function makeCompleteRegistrationFromInvitation(): CompleteRegistrationFromInvitation {
  return new EdgeCompleteRegistrationRepository(makeSupabaseEdgeHttpClient()).execute
}
